/*
 **	User name
 **	Created	5/24/2023
 **	index.js
 */

import React from "react";
import NotFound from "../work_inprogress/notFound";

function PageNotFound() {
  return <NotFound />;
}

export default PageNotFound;
